import { connect } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { Variable } from '@optimus-web/common';
import { ButtonVariant } from '@optimus-web/core';
import { getCurrentEnterpriseReservationAssignedResourceId } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { CheckInButton } from '../CheckInButton';
import ReservationCheckInDialog from './ReservationCheckInDialog';

interface StateProps {
    assignedResourceId?: string | null;
}
interface OwnProps extends Variable<ButtonVariant> {
    reservationId: string;
    active: boolean;
    withCheckInButton?: boolean;
    onButtonClick: () => void;
    onClose: () => void;
    onUpdate: () => void;
}

export type ReservationCheckInActionProps = OwnProps & StateProps;
const ReservationCheckInAction = ({
    reservationId,
    assignedResourceId,
    variant,
    withCheckInButton,
    active,
    onButtonClick,
    onClose,
    onUpdate,
}: ReservationCheckInActionProps) => {
    if (!assignedResourceId) return null;

    const onSuccess = () => {
        onUpdate();
        onClose();
    };

    return (
        <>
            {withCheckInButton ? (
                <CheckInButton
                    variant={variant}
                    onClick={onButtonClick}
                    data-test-reservation-check-in={reservationId}
                    type="submit"
                />
            ) : null}
            <ReservationCheckInDialog
                active={active}
                closeDialog={onClose}
                reservationId={reservationId}
                onSuccess={onSuccess}
                assignedResourceId={assignedResourceId}
            />
        </>
    );
};

export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { reservationId }) => ({
    assignedResourceId: getCurrentEnterpriseReservationAssignedResourceId(state, { id: reservationId }),
}))(ReservationCheckInAction);
